module.exports = __webpack_public_path__ + "static/media/tourist.a883700d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/tourist.jpg
// module id = 31
// module chunks = 0